'use client';

import { NAVIGATION_CONSTANTS } from '@fdc/constants/navigation.constants';
import { useAppRouter } from '@fdc/hooks/useAppRouter';
import { openChatWidget } from '@fdc/utils/chat-widget';
import { CoreButton } from '@woolworthslimited/core-components-react/button';
import { CoreLink } from '@woolworthslimited/core-components-react/link';
import { useWindowDimension } from '@woolworthslimited/core-components-react/shared/hooks/useWindowDimension';
import Link from 'next/link';

import { isMediumDeviceOrGreater } from '@contentservice/shared/services/breakpoint/breakpoint.service';

import styles from './no-search-results.module.scss';

export type NoSearchResultsProps = {
  searchTerm?: string;
};

export const NoSearchResults: React.FC<NoSearchResultsProps> = ({
  searchTerm,
}) => {
  const router = useAppRouter();
  const [width] = useWindowDimension(false);
  const largeDevice = isMediumDeviceOrGreater(width);
  const searchTitle = `We couldn't find results for "${searchTerm}"`;

  const handleOpenOliveChat = (e?: React.MouseEvent) => {
    e?.preventDefault();
    openChatWidget();
  };
  return (
    <div className={styles.noSearchResult}>
      <div className={styles.title}>{searchTitle}</div>
      <div className={styles.searchTipsTitle}>Search tips</div>
      <div className={styles.searchTipsDetail}>
        <ul className={styles.searchTipsList}>
          <li>
            <span className={styles.emphasis}>Use less specific words</span>.
            For example, “breakfast cereal” instead of “organic wholegrain
            muesli”.
          </li>
          <li>
            <span className={styles.emphasis}>Remove brand names</span>. For
            example, “chicken thighs” instead of “Woolworths chicken thighs”.
          </li>
          <li>
            Tobacco, alcohol, and other restricted items will not show unless
            you’re over 18 and signed in.
          </li>
          <li>
            Browse our{' '}
            <Link
              prefetch={false}
              href={NAVIGATION_CONSTANTS.SPECIALS_OFFERS}
              className={styles.specialsLink}
            >
              Specials
            </Link>{' '}
            and popular categories.
          </li>
        </ul>
        <div className={styles.tryAgainMsg}>
          Please try again or contact us through our{' '}
          <CoreLink
            as="button"
            label="chatbot Olive"
            clickHandler={handleOpenOliveChat}
          />{' '}
          if you need help.
        </div>
      </div>
      <div className={styles.actions}>
        <CoreButton
          as="a"
          label="Go to home page"
          variant="primary"
          size="medium"
          isFullWidth={width && !largeDevice}
          clickHandler={() => router.push(NAVIGATION_CONSTANTS.HOME_PAGE)}
        ></CoreButton>
        <CoreButton
          as="a"
          label="Chat with Olive"
          variant="secondary"
          size="medium"
          isFullWidth={width && !largeDevice}
          clickHandler={handleOpenOliveChat}
        ></CoreButton>
      </div>
    </div>
  );
};
